import {
  Box,
  CircularProgress,
  Divider,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import FindInPageOutlinedIcon from "@material-ui/icons/FindInPageOutlined"
import ButtonRounded from "components/Common/ButtonRounded"
import ChipSquare from "components/Common/ChipSquare"
import dayjs from "dayjs"
import PropTypes from "prop-types"

import useStyles from "./styles"

const Step1 = ({ applicantData, setStep, setCurrentApplication, loading }) => {
  const classes = useStyles()
  const theme = useTheme()
  const mobileView = useMediaQuery(theme.breakpoints.down("xs"))

  const viewApplication = (application) => {
    setCurrentApplication(application)
    setStep(+1)
  }

  return (
    <Box style={!loading ? { alignSelf: "flex-start", flexGrow: 1 } : null}>
      {loading ? (
        <Box display="flex" justifyContent="center" pt="30%" pb="30%">
          <CircularProgress color="primary" size={30} />
        </Box>
      ) : (
        <>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            flexGrow={1}
            style={mobileView ? { display: "none" } : null}
          >
            <Box display="flex" width="80%" marginBottom="20px">
              <Box className={classes.boardNameBox}>
                <Typography color="primary">Board Name</Typography>
              </Box>
              <Box className={classes.dateBox}>
                <Typography color="primary">Submitted </Typography>
              </Box>
              <Box className={classes.statusBox}>
                <Typography color="primary">Status</Typography>
              </Box>
            </Box>
          </Box>
          {applicantData?.map((a, i) => {
            return (
              <Box key={i}>
                <Box className={classes.row}>
                  {!mobileView ? (
                    <>
                      <Box className={classes.boardData}>
                        <Box className={classes.boardNameBox}>
                          <Typography variant="body2">{a?.name}</Typography>
                        </Box>
                        <Box className={classes.dateBox}>
                          <Typography>
                            {dayjs(a?.submitted).format(
                              "dddd, MMMM D, YYYY h:mm A"
                            )}
                          </Typography>
                        </Box>
                        <Box className={classes.statusBox}>
                          <ChipSquare
                            status={{ label: a?.status, id: a?.status_id }}
                          />
                        </Box>
                      </Box>
                      <ButtonRounded
                        color="primary"
                        onClick={() => viewApplication(a)}
                      >
                        View
                      </ButtonRounded>
                    </>
                  ) : (
                    <>
                      <Box className={classes.leftHalf}>
                        <Box className={classes.boardNameBox}>
                          <Typography variant="body2">{a?.name}</Typography>
                        </Box>
                        <Box className={classes.dateBox}>
                          <Typography>
                            {dayjs(a?.submitted).format(
                              "dddd, MMMM D, YYYY h:mm A"
                            )}
                          </Typography>
                        </Box>
                      </Box>
                      <Box className={classes.rightHalf}>
                        <Box className={classes.statusBox}>
                          <ChipSquare
                            status={{ label: a?.status, id: a?.status_id }}
                          />
                        </Box>
                        <Box className={classes.buttonBox}>
                          <IconButton
                            color="primary"
                            onClick={() => viewApplication(a)}
                          >
                            <FindInPageOutlinedIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </>
                  )}
                </Box>
                <Divider />
              </Box>
            )
          })}
        </>
      )}
    </Box>
  )
}
Step1.propTypes = {
  mutation: PropTypes.object,
  setStep: PropTypes.func,
  setCurrentApplication: PropTypes.func,
  applicantData: PropTypes.array,
  loading: PropTypes.bool,
  user: PropTypes.object,
}
export default Step1
